
export const getItems = (access) => {
  const items = [
    {
      label: "DASHBOARD",
      icon: "pi pi-th-large",
      path: "dashboard",
      key: "dashboard",
      visible: true,
    },
    {
      label: "FAVOURITES",
      icon: "pi pi-heart",
      key: "favourites",
      items: [],
    },
    {
      label: "AFFILIATE MANAGER",
      icon: "pi pi-users",
      key: "affiliate-manager",
      visible: access?.affiliateManagerMenu?.view,
      items: [
        {
          label: "Affiliate Dashboard",
          path: "affiliate-dashboard",
          key: "affiliate-dashboard",
          visible: access?.affiliateDashboardMenu?.view ?? false,
        },
        {
          label: "Affiliate",
          path: "affiliate",
          key: "affiliate-list",
          visible: access?.affiliateMenu?.view ?? false,
        },
        {
          label: "Affiliate Report",
          path: "affiliate-report",
          key: "affiliate-report",
          visible: access?.affiliateReportMenu?.view ?? false,
        },
        {
          label: "Affiliate Invoices",
          path: "affiliate-invoices",
          key: "affiliate-invoices",
          visible: access?.affiliateInvoiceMenu?.view ?? false,
        },
      ],
    },
    {
      label: "LOCATION MANAGER",
      icon: "pi pi-map",
      key: "location-manager",
      visible: access?.locationManagerMenu?.view,
      items: [
        {
          label: "Location",
          path: "location",
          key: "location",
          visible: access?.locationsMenu?.view,
        },
        {
          label: "Settings",
          path: "#",
          key: "settings",
          visible: access?.settingsMenu?.view,
          items: [
            {
              label: "Days of Week",
              path: "days-of-week",
              key: "days-of-week",
              visible: access?.daysOfWeekMenu?.view,
            },
            {
              label: "Pay Now Discount",
              path: "pay-now-discount",
              key: "pay-now-discount",
              visible: access?.payNowDiscountMenu?.view,
            },
            {
              label: "Pay Now Option",
              path: "pay-now-option",
              key: "pay-now-option",
              visible: access?.payNowOptionMenu?.view,
            },
          ],
        },
        {
          label: "Holidays",
          path: "holidays",
          key: "holidays",
          visible: access?.holidaysMenu?.view,
        },
        {
          label: "Reservation",
          path: "reservations",
          key: "reservations",
          visible: access?.reservationsMenu2?.view,
        },
        {
          label: "Vehicles",
          path: "#",
          key: "vehicles",
          visible: access?.vehiclesMenu3?.view,
          items: [
            {
              label: "Vehicle Category",
              path: "vehicle-category",
              key: "vehicle-category",
              visible: access?.vehicleCategoryMenu?.view,
            },
            {
              label: "Make",
              path: "vehicle-make",
              key: "vehicle-make",
              visible: access?.makeMenu?.view,
            },
            {
              label: "Model",
              path: "vehicle-model",
              key: "vehicle-model",
              visible: access?.modelMenu?.view,
            },
            {
              label: "Trim",
              path: "vehicle-trim",
              key: "vehicle-trim",
              visible: access?.trimMenu?.view,
            },
            {
              label: "Vehicle Transmission Type",
              path: "vehicle-transmission-type",
              key: "vehicle-transmission-type",
              visible: access?.transmissionTypeMenu?.view,
            },
            {
              label: "Vehicle AcType",
              path: "vehicle-ac-type",
              key: "vehicle-ac-type",
              visible: access?.acTypeMenu?.view,
            },
            {
              label: "Vehicle StereoType",
              path: "vehicle-stereo-type",
              key: "vehicle-stereo-type",
              visible: access?.stereoTypeMenu?.view,
            },
            // {
            //   label: "Vehicle VehicleOperations",
            //   path: "vehicle-operations",
            //   key: "vehicle-operations",
            //   visible: access?.vehicleOperationsMenu?.view,
            // },
          ],
        },
        // {
        //   label: "Incident",
        //   path: "incident",
        //   key: "incident",
        //   visible: access?.incidentMenu?.view,
        //   items: [
        //     {
        //       label: "Fault Values",
        //       path: "fault-values",
        //       key: "fault-values",
        //       visible: access?.faultValuesMenu?.view,
        //     },
        //     {
        //       label: "Incident Report",
        //       path: "incident-report",
        //       key: "incident-report",
        //       visible: access?.incidentReportMenu?.view,
        //     },
        //   ],
        // },
      ],
    },
    {
      label: "RATE MANAGER",
      icon: "pi pi-dollar",
      key: "rate-manager",
      visible: access?.rateManagerMenu?.view,
      items: [
        {
          label: "Rate Code",
          path: "rate-code",
          key: "rate-code",
          visible: access?.rateCodeMenu?.view,
        },
        {
          label: "Rate Plans",
          path: "rate-plans",
          key: "rate-plans",
          visible: access?.ratePlansMenu?.view,
        },
        {
          label: "Rate Types",
          path: "rate-types",
          key: "rate-types",
          visible: access?.rateTypesMenu?.view,
        },
        {
          label: "Lor Adjustments",
          path: "lor-adjustments",
          key: "lor-adjustments",
          visible: access?.lorAdjustmentsMenu?.view,
        },
        {
          label: "Rates",
          path: "rates",
          key: "rates",
          visible: access?.ratesMenu?.view,
        },
        {
          label: "Advance Rate",
          path: "advance-rate-update",
          key: "advance-rate",
          visible: access?.advanceRateMenu?.view ?? false,
        },
        {
          label: "Extra Product Category",
          path: "extra-product-category",
          key: "extra-product-category",
          visible: access?.extraProductCategoryMenu?.view,
        },
        {
          label: "Extra Product Charge",
          path: "extra-product-charge",
          key: "extra-product-charge",
          visible: access?.extraProductChargeMenu?.view,
        },
        {
          label: "Blackouts",
          path: "blackouts",
          key: "blackouts",
          visible: access?.blackoutsMenu?.view,
        },
        {
          label: "Rate Mirrors",
          path: "rate-mirrors",
          key: "rate-mirrors",
          visible: access?.rateMirrorMenu?.view,
        },
        {
          label: "Networks",
          path: "networks",
          key: "networks",
          visible: access?.networksMenu?.view,
        },
      ],
    },
    {
      label: "RESERVATION MANAGER",
      icon: "pi pi-book",
      key: "reservation-manager",
      visible: access?.reservationManagerMenu?.view,
      items: [
        // {
        //   label: "Rate Quotes",
        //   path: "quotes",
        //   key: "quotes",
        //   visible: access?.rateQuotesMenu?.view,
        // },
        {
          label: "Reservations",
          key: "reservation",
          visible: access?.reservationsMenu?.view,
          items: [
            {
              label: "Reservation",
              path: "reservations-reservations",
              key: "reservations",
              visible: access?.reservationsMenu3?.view,
            },
            {
              label: "Reservation Detail Report",
              path: "reservation-detail-report",
              key: "reservation-detail-report",
              visible: access?.reservationsDetailReportNewMenu?.view,
            },
            {
              label: "Daily Manifest Report",
              path: "daily-manifest-report",
              key: "daily-manifest-report",
              visible: access?.dailyManifestReportNewMenu?.view,
            },
            {
              label: "Bookings by Location Report",
              path: "bookings-by-location",
              key: "bookings-by-location",
              visible: access?.bookingsByLocationReportNewMenu?.view,
            },
            {
              label: "Prepaid Bookings Report",
              path: "prepaid-bookings",
              key: "prepaid-bookings",
              visible: access?.prepaidBookingsReportNewMenu?.view,
            },
            // {
            //   label: "CRX/Rezp Reservations",
            //   path: "crx-rezp-reservations",
            //   key: "crx-rezp-reservations",
            //   visible: access?.crxrezpReservationsMenu?.view,
            // },
          ],
        },
        {
          label: "Reservation Reports",
          key: "reservation-reports",
          visible: access?.reservationsReportsMenu?.view,
          items: [
            {
              label: "Reservations by Location & Network",
              path: "reservations-by-location-and-network",
              key: "reservations-by-location-and-network",
              visible: access?.reservationsByLocationAndNetworkMenu?.view,
            },
            {
              label: "Revenue By Network",
              path: "revenue-by-network",
              key: "revenue-by-network",
              visible: access?.revenueByNetworkMenu?.view,
            },
          ],
        },
        // {
        //   label: "Transactions",
        //   path: "transactions",
        //   key: "transactions",
        //   visible: access?.transactionsMenu?.view,
        // },
        // {
        //   label: "Bids",
        //   path: "bids",
        //   key: "bids",
        //   visible: access?.bidsMenu?.view,
        // },
        // {
        //   label: "Vehicles",
        //   path: "vehicles",
        //   key: "vehicle",
        //   visible: access?.vehiclesMenu2?.view,
        // },
        // {
        //   label: "Calendar",
        //   path: "#",
        //   key: "calendar",
        //   visible: access?.calendarMenu?.view,
        //   items: [
        //     {
        //       label: "Calendar Pickup",
        //       path: "calendar-pickup",
        //       key: "calendar-pickup",
        //       visible: access?.calendarPickupMenu?.view,
        //     },
        //     {
        //       label: "Calendar Dropoff",
        //       path: "calendar-dropoff",
        //       key: "calendar-dropoff",
        //       visible: access?.calendarDropoffMenu?.view,
        //     },
        //   ],
        // },
      ],
    },
    {
      label: "COUNTER MANAGER",
      icon: "pi pi-desktop",
      key: "counter-manager",
      visible: access?.counterManagerMenu?.view,
      items: [
        // {
        //   label: "Revenue Agreements",
        //   path: "revenue-agreements",
        //   key: "revenue-agreements",
        //   visible: access?.revenueAgreementsMenu?.view,
        // },
        // {
        //   label: "Non Revenue Agreements",
        //   path: "non-revenue-agreements",
        //   key: "non-revenue-agreements",
        //   visible: access?.nonRevenueAgreementsMenu?.view,
        // },
        {
          label: "Vehicle",
          path: "vehicle-operations",
          key: "vehicle-operations",
          visible: access?.vehiclesMenu?.view,
        },
        {
          label: "Vehicle Status",
          path: "vehicle-status",
          key: "vehicle-status",
          visible: access?.vehicleStatusMenu?.view,
        },
        // {
        //   label: "Maintenance",
        //   path: "#",
        //   key: "maintenance",
        //   visible: access?.maintenanceMenu?.view,
        //   items: [
        //     {
        //       label: "Maintenance Category",
        //       path: "maintenance-category",
        //       key: "maintenance-category",
        //       visible: access?.maintenanceCategoryMenu?.view,
        //     },
        //     {
        //       label: "Maintenance Records",
        //       path: "maintenance-records",
        //       key: "maintenance-records",
        //       visible: access?.maintenanceRecordsMenu?.view,
        //     },
        //   ],
        // },
        // {
        //   label: "Body/Repair Shops",
        //   path: "body-repair-shops",
        //   key: "body-repair-shops",
        //   visible: access?.bodyrepairShopsMenu?.view,
        // },
        {
          label: "Dealerships",
          path: "vehicle-dealerships",
          key: "dealerships",
          visible: access?.dealershipsMenu?.view,
        },
        // {
        //   label: "Vehicle Inquiries",
        //   path: "vehicle-inquiries",
        //   key: "vehicle-inquiries",
        //   visible: access?.vehicleInquiriesMenu?.view,
        // },
        // {
        //   label: "Dealership Vehicle Deals",
        //   path: "vehicle-dealership-vehicle-deal",
        //   key: "dealership-vehicle-deals",
        //   visible: access?.dealershipVehicleDealsMenu?.view,
        // },
        // {
        //   label: "Claims Manager",
        //   path: "#",
        //   key: "claims-manager",
        //   visible: access?.claimsManagerMenu?.view,
        //   items: [
        //     {
        //       label: "Claims Cost Category",
        //       path: "claims-cost-category",
        //       key: "claims-cost-category",
        //       visible: access?.claimCostCategoryMenu?.view,
        //     },
        //     {
        //       label: "Claims",
        //       path: "claims",
        //       key: "claims",
        //       visible: access?.claimsMenu?.view,
        //     },
        //   ],
        // },
        // {
        //   label: "Broadcast Meassages",
        //   path: "#",
        //   key: "broadcast-meassages",
        //   visible: access?.broadcastMeassagesMenu?.view,
        //   items: [
        //     {
        //       label: "Staff Dashboard",
        //       path: "broadcast-messages",
        //       key: "Staff Dashboard",
        //       visible: access?.staffDashboardMenu?.view,
        //     },
        //   ],
        // },
      ],
    },
    {
      label: "WEBSITE MANAGER",
      icon: "pi pi-globe",
      key: "website-manager",
      visible: access?.websiteManagerMenu?.view,
      items: [
        // {
        //   label: "Blogs",
        //   path: "blogs",
        //   key: "blogs",
        //   visible: access?.blogsMenu?.view,
        // },
        // {
        //   label: "Newsletters",
        //   path: "#",
        //   key: "newsletters-menager",
        //   visible: access?.newslettersMenu?.view,
        //   items: [
        //     {
        //       label: "Newsletters",
        //       path: "newsletters",
        //       key: "newsletters",
        //       visible: access?.newslettersMenu?.view,
        //     },
        //     {
        //       label: "Newsletters Subscribers",
        //       path: "newsletters-subscribers",
        //       key: "newsletters-subscribers",
        //       visible: access?.newslettersSubscribersMenu?.view,
        //     },
        //   ],
        // },
        // {
        //   label: "Career",
        //   path: "#",
        //   key: "career",
        //   visible: access?.careerMenu?.view,
        //   items: [
        //     {
        //       label: "Career Positions",
        //       path: "career-positions",
        //       key: "career-positions",
        //       visible: access?.careerPositionsMenu?.view,
        //     },
        //     {
        //       label: "Career Applications",
        //       path: "career-applications",
        //       key: "career-applications",
        //       visible: access?.careerApplicationsMenu?.view,
        //     },
        //   ],
        // },
        // {
        //   label: "Promotion",
        //   path: "#",
        //   key: "promotion",
        //   visible: access?.promotionMenu?.view,
        //   items: [
        //     {
        //       label: "Home Sliders",
        //       path: "home-sliders",
        //       key: "home-sliders",
        //       visible: access?.homeSlidersMenu?.view,
        //     },
        //     {
        //       label: "Home Info Slider",
        //       path: "home-info-slider",
        //       key: "home-info-slider",
        //       visible: access?.homeInfoSliderMenu?.view,
        //     },
        //     {
        //       label: "Discount Codes",
        //       path: "discount-codes",
        //       key: "discount-codes",
        //       visible: access?.discountCodesMenu?.view,
        //     },
        //     {
        //       label: "Coupon",
        //       path: "coupon",
        //       key: "coupon",
        //       visible: access?.couponMenu?.view,
        //     },
        //   ],
        // },
        // {
        //   label: "Forms",
        //   path: "#",
        //   key: "forms",
        //   visible: access?.formsMenu?.view,
        //   items: [
        //     {
        //       label: "Lost & Found Inquiries",
        //       path: "lost-found-inquiries",
        //       key: "lost-found-inquiries",
        //       visible: access?.lostFoundInquiriesMenu?.view,
        //     },
        //     {
        //       label: "Contact Queries",
        //       path: "contact-queries",
        //       key: "contact-queries",
        //       visible: access?.contactQueriesMenu?.view,
        //     },
        //   ],
        // },

        // {
        //   label: "Traffic Logs",
        //   path: "traffic-logs",
        //   key: "traffic-logs",
        //   visible: access?.trafficLogsMenu?.view,
        // },
        {
          label: "Renters",
          path: "#",
          key: "renters",
          visible: access?.rentersMenu?.view,
          items: [
            {
              label: "Registered Renters",
              path: "registered-renters",
              key: "registered-renters",
              visible: access?.registeredRentersMenu?.view,
            },
            {
              label: "Renters Info",
              path: "renters-info",
              key: "renters-info",
              visible: access?.rentersInfoMenu?.view,
            },
            // {
            //   label: "Renter Interaction Log",
            //   path: "renter-interaction-log",
            //   key: "renter-interaction-log",
            //   visible: access?.renterLogInteractionsMenu?.view,
            // },
          ],
        },
      ],
    },
    // {
    //   label: "OPERATIONS MANAGER",
    //   icon: "pi pi-briefcase",
    //   key: "operations-manager",
    //   visible: access?.operationsManagerMenu?.view,
    //   items: [
    //     {
    //       label: "Task Assignment",
    //       path: "task-assignment",
    //       key: "task-assignment",
    //       visible: access?.taskAssignmentMenu?.view,
    //       items: [
    //         {
    //           label: "Task Management System",
    //           path: "task-management-system",
    //           key: "ask-management-system",
    //           visible: access?.taskManagementSystemMenu?.view,
    //         },
    //         { 
    //           label: "Calendar", 
    //           path: "calendar", 
    //           key: "calendar",
    //           visible: access?.calendarMenu3?.view,
    //         },
    //         {
    //           label: "Recurring to do list",
    //           path: "recurring-to-do-list",
    //           key: "recurring-to-do-list",
    //           visible: access?.recurringToDoListMenu?.view,
    //         },
    //       ],
    //     },
    //     {
    //       label: "Admin",
    //       path: "admin",
    //       key: "admin",
    //       visible: access?.adminMenu?.view,
    //       items: [
    //         {
    //           label: "Corporate Meetings",
    //           path: "corporate-meetings",
    //           key: "corporate-meetings",
    //           visible: access?.corporateMeetingsMenu?.view,
    //         },
    //         {
    //           label: "Leave Applications",
    //           path: "leave-applications",
    //           key: "leave-applications",
    //           visible: access?.leaveApplicationsMenu?.view,
    //         },
    //       ],
    //     },
    //     {
    //       label: "Financial",
    //       path: "financial",
    //       key: "financial",
    //       visible: access?.financialMenu?.view,
    //       items: [
    //         {
    //           label: "Time and Billing",
    //           path: "time-and-billing",
    //           key: "time-and-billing",
    //           visible: access?.timeAndBillingMenu?.view,
    //         },
    //         {
    //           label: "Vendors",
    //           path: "vendors",
    //           key: "vendors",
    //           visible: access?.vendorsMenu?.view,
    //         },
    //         {
    //           label: "Invoicing",
    //           path: "invoicing",
    //           key: "invoicing",
    //           visible: access?.invoicingMenu?.view,
    //         },
    //         {
    //           label: "Wholesale Bill of Sale",
    //           path: "wholesale-bill-of-sale",
    //           key: "wholesale-bill-of-sale",
    //           visible: access?.wholesaleBillOfSaleMenu?.view,
    //         },
    //         {
    //           label: "A/R",
    //           path: "accounts-receivable",
    //           key: "accounts-receivable",
    //           visible: access?.arMenu?.view,
    //         },
    //         {
    //           label: "Misc Uploads",
    //           path: "misc-uploads",
    //           key: "misc-uploads",
    //           visible: access?.miscUploadsMenu?.view,
    //         },
    //         {
    //           label: "Rental Checklist",
    //           path: "rental-checklist",
    //           key: "rental-checklist",
    //           visible: access?.rentalChecklistMenu?.view,
    //         },
    //       ],
    //     },
    //     {
    //       label: "Communication",
    //       path: "communication",
    //       key: "communication",
    //       visible: access?.communicationMenu?.view,
    //       items: [
    //         {
    //           label: "Send Notifications",
    //           path: "send-notifications",
    //           key: "send-notifications",
    //           visible: access?.sendNotificationsMenu?.view,
    //         },
    //         {
    //           label: "Send Bulk Email",
    //           path: "send-bulk-email",
    //           key: "send-bulk-email",
    //           visible: access?.sendBulkEmailMenu?.view,
    //         },
    //         {
    //           label: "Send Bulk SMS",
    //           path: "send-bulk-sms",
    //           key: "send-bulk-sms",
    //           visible: access?.sendBulkSmsMenu?.view,
    //         },
    //       ],
    //     },
    //     {
    //       label: "Staff",
    //       path: "staff",
    //       key: "staff",
    //       visible: access?.staffMenu?.view,
    //     },
    //     {
    //       label: "Calendar",
    //       path: "calendar",
    //       key: "calendar",
    //       visible: access?.calendarMenu2?.view,
    //     },
    //   ],
    // },
    {
      label: "SYSTEM MANAGER",
      icon: "pi pi-cog",
      key: "system-manager",
      visible: access?.systemManagerMenu?.view,
      items: [
        {
          label: "Users",
          path: "users",
          key: "users",
          visible: access?.usersMenu?.view,
        },
        {
          label: "Roles",
          path: "roles",
          key: "roles",
          visible: access?.rolesMenu?.view,
        },
        {
          label: "Company",
          path: "company",
          key: "company",
          visible: access?.companyMenu?.view && localStorage.getItem('companyId') === '1',
        },
      ],
    },
  ];
  return items;
};
